module.exports = __webpack_public_path__ + "img/42.b7cf20d2.jpg";